  <template lang="pug">
  .module__main
    .module__title Список заявок
    .module-content__container
      .filters__container
        .filter__container
          .filter__title Статус
          .active-status__container
            el-select(v-model="activeMode" @change="loadOrders()")
              el-option(v-for="option in activeOptions" :key="`active-option-${option.key}`" :label="option.locale" :value="option.key")
        .filter__container
          .filter__title Система
          .active-status__container
            el-select(v-model="paymentSystemMode" @change="loadOrders()")
              el-option(label="Все" value="")
              el-option(v-for="(alias, paymentSystem) in paymentSystems" :key="`ps-option-${paymentSystem}`" :label="alias" :value="paymentSystem")
        .filter__container
          .filter__title Период
          .dates__container
            .date__container
              .date__title От
              el-date-picker(
                v-model="timeFrom"
                type="datetime"
                value-format="timestamp"
              )
            .date__container
              .date__title До
              el-date-picker(
                v-model="timeTo"
                type="datetime"
                value-format="timestamp"
              )
        .filter__container(v-if="activeMode === 'finished'")
          .filter__title Причина завершения
          .finish-reason__container
            el-select(v-model="finishReason" @change="loadOrders()")
              el-option(label="Все" value="all" key="search-finish-reason-all")
              el-option(
                v-for="(reason, value) in finishReasons"
                :key="`search-finish-reason-${value}`"
                :label="reason.description"
                :value="value"
              )
        .filter__container.search
          .filter__title Критерии поиска
          .search__container
            el-select(v-model="searchMode" @change="updateDefaultSearchMode()")
              el-option(v-for="(mode, key) in searchModes" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
            el-input(v-model="searchValue" :placeholder="searchModes[searchMode].title")
              i.el-input__icon.el-icon-search(slot="suffix" @click="searchOrder()")
            i.el-icon-close.search-reset__btn(v-if="searchLoaded" @click="resetSearch()")
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedOrders"
            style="width: 100%; font-size: 12px",
            :row-class-name="tableRowClassName"
          )
            el-table-column(label="ID" width="100")
              template(slot-scope="scope")
                .id__container
                  i.el-icon-document-copy.copy__btn(@click="copyOrderInfo(scope.row)")
                  span {{ scope.row.id }}
                  span(v-if="scope.row.deal_id") {{ ` (${scope.row.deal_id})` }}
                  .val(v-if="scope.row.code") {{ ` (${scope.row.code})` }}
                  .val(v-if="scope.row.deal_trader") {{ ` (${scope.row.deal_trader})` }}
                .id__container(v-if="scope.row.handler")
                  span {{ `(${scope.row.handler})` }}
            el-table-column(prop="payment_system" label="Система" width="120")
              template(slot-scope="scope")
                .val {{ scope.row.payment_system }}
                .val(v-if="scope.row.interbank_name") ({{ scope.row.interbank_name }})
            el-table-column(prop="fiat_amount" label="Фиат" width="100")
            el-table-column(v-if="isAdmin || isPartner" label="BTC" width="160")
              template(slot-scope="scope")
                .val(v-if="scope.row.btc_deal")
                  span.col-title Обработчик:
                  span {{ scope.row.btc_deal }}
                .val(v-if="scope.row.btc_sell")
                  span.col-title Партнер:
                  span {{ scope.row.btc_sell }}
                .val(v-if="scope.row.btc_exchange")
                  span.col-title Клиент:
                  span {{ scope.row.btc_exchange }}
                .val(v-if="scope.row.profit")
                  span.col-title Прибыль:
                  span {{ scope.row.profit }}
            el-table-column(v-if="isAdmin || isPartner" label="Курс" width="160")
              template(slot-scope="scope")
                .val(v-if="scope.row.rate_deal")
                  span.col-title Обработчик:
                  span {{ scope.row.rate_deal }}
                .val(v-if="scope.row.rate_sell")
                  span.col-title Партнер:
                  span {{ scope.row.rate_sell }}
                .val(v-if="scope.row.rate_exchange")
                  span.col-title Клиент:
                  span {{ scope.row.rate_exchange }}
            el-table-column(prop="status" label="Статус" width="180")
              template(slot-scope="scope")
                .val {{ statusesLocales[scope.row.status] || scope.row.status }}
                .finish-details(v-if="scope.row.status === 'finished'")
                  .val {{ `Время: ${scope.row.finished || scope.row.updated}` }}
                  .val(v-if="scope.row.finished_by && scope.row.finished_by !== 'system'") {{ `Закрыл: ${scope.row.finished_by}` }}
                  .val(v-if="scope.row.finish_reason") {{ `Причина: ${finishReasons[scope.row.finish_reason] ? finishReasons[scope.row.finish_reason].description : scope.row.finish_reason}` }}
                .status-details(v-else)
                  .val(v-if="scope.row.showCancelReason") {{ `(${scope.row.cancel_reason})` }}
                  .val(v-if="scope.row.error") {{ `(${scope.row.error})` }}
                  .val(v-if="scope.row.claim") {{ `Открыта ${scope.row.claim.created} на сумму ${scope.row.claim.fiat_amount} р.` }}
            el-table-column(prop="requisites" label="Реквизит" width="150")
              template(slot-scope="scope")
                .val
                  .requisite__text(:class="{ 'black-list-user': scope.row.isBlackListRequisite }")
                    a(v-if="scope.row.isLink" :href="scope.row.requisites" target="_blank") {{ formatRequisitesUrl(scope.row.requisites) }}
                    span(v-else) {{ scope.row.requisites }}
                    i.order-black-list__btn.el-icon-unlock.color-success(
                      v-if="scope.row.requisites && scope.row.isBlackListRequisite"
                      @click="changeBlackListStatus(scope.row.requisites, 'delete', 'requisite')"
                    )
                    i.order-black-list__btn.el-icon-lock.color-danger(
                      v-else-if="scope.row.requisites && !scope.row.isBlackListRequisite"
                      @click="openBlacklistAdd(scope.row.requisites, 'requisite')"
                    )
                .val(v-if="scope.row.requisites_bank") ({{ scope.row.requisites_bank }})
                .val(v-if="scope.row.requisites_country") ({{ scope.row.requisites_country }})
                .val(v-if="scope.row.requisites_recipient") ({{ scope.row.requisites_recipient }})
            el-table-column(label="Клиент" width="100")
              template(slot-scope="scope")
                span(:class="{ 'black-list-user': scope.row.isBlackListUser }") {{ scope.row.client_id }}
                i.order-black-list__btn.el-icon-unlock.color-success(
                  v-if="scope.row.client_id && scope.row.isBlackListUser"
                  @click="changeBlackListStatus(scope.row.client_id, 'delete', 'user')"
                )
                i.order-black-list__btn.el-icon-lock.color-danger(
                  v-else-if="scope.row.client_id && !scope.row.isBlackListUser"
                  @click="openBlacklistAdd(scope.row.client_id, 'user')"
                )
            el-table-column(prop="created" label="Создана" width="150")
            el-table-column(label="Пометки" v-if="!isPartner" width="100")
              template(slot-scope="scope")
                .notes__container
                  i.note-icon.el-icon-warning-outline(
                    :class="{ 'color-danger': scope.row.notes.problem }"
                    :title="scope.row.notes.problem ? 'Отмечена проблемной' : 'Отметить проблемной'"
                    @click="handleOrderNote(scope.row, 'problem')"
                  )
                  i.note-icon.el-icon-coin(
                    :class="{ 'color-success': scope.row.notes.paid }"
                    :title="scope.row.notes.problem ? 'Отмечена оплаченной' : 'Отметить оплаченной'"
                    @click="handleOrderNote(scope.row, 'paid')"
                  )
            el-table-column(label="Действия" v-if="showActionButtons" width="180")
              template(slot-scope="scope")
                .order-action__buttons
                  .action__btn(v-if="scope.row.isCanFinish")
                    el-button(
                      @click="openOrderModifying(scope.row.id, scope.row.fiat_amount, 'finish', scope.row.status)"
                      title="Завершить"
                      icon="el-icon-check"
                      type="success"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanClaim")
                    el-button(
                      @click="openOrderModifying(scope.row.id, scope.row.fiat_amount, 'claim', scope.row.status)"
                      title="Претензия"
                      icon="el-icon-warning-outline"
                      type="warning"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanCancelClaim")
                    el-button(
                      @click="startCancelClaim(scope.row.id)"
                      title="Отмена претензии"
                      icon="el-icon-circle-close"
                      type="danger"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanCancel")
                    el-button(
                      @click="startCancelOrder(scope.row.id)"
                      title="Отменить"
                      icon="el-icon-close"
                      type="danger"
                      size="mini"
                      circle
                    )
                  .action__btn(@click="openOrderComments(scope.row.id, scope.row.comments)")
                    el-button(
                      title="Комментарии"
                      icon="el-icon-tickets"
                      type="primary"
                      size="mini"
                      circle
                    )
                    .comments__badge(v-if="scope.row.comments") {{ scope.row.comments.length }}
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='orders.pagination.count',
            :page-size="per_page",
            :current-page='orders.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadOrders',
          )
    el-dialog(:visible.sync="isOrderModifying" :before-close="resetOrderModifying" :title="modifyingOrderTitle" width="50%")
      .modify__container
        .original-amount {{ `Сумма в заявке: ${modifyingOrder.original_amount} р.` }}
        .modify-amount
          .title {{ modifyingOrder.mode === 'finish' ? 'Сумма завершения' : 'Сумма претензии' }}
          el-input(v-model="modifyingOrder.amount" :disabled="!modifyingOrder.can_change_amount" type="number")
        .finish-reason(v-if="modifyingOrder.mode === 'finish'")
          .finish-reason-param
            .title Причина завершения
            el-select(v-model="modifyingOrder.finish_reason")
              el-option(
                v-for="(reason, value) in finishReasons"
                v-if="reason.availableOption"
                :value="value"
                :label="reason.description"
                :key="`finish_reason_${value}`"
              )
          .finish-reason-param(v-if="modifyingOrder.finish_reason === 'compensation' || modifyingOrder.finish_reason === 'duplicate'")
            .title ID связной заявки
            el-input(v-model="modifyingOrder.compensation_order_id" placeholder="Введите ID связной заявки")
        .finish-reason(v-if="modifyingOrder.mode === 'claim'")
          .title Ссылка на чек
          el-input(v-model="modifyingOrder.attachment_link")
        .requisite-add__buttons
          el-button(
            type="success"
            :disabled="modifyingOrder.mode === 'finish' && !modifyingOrder.finish_reason"
            @click="startModifyOrder()"
          ) {{ modifyingOrder.mode === 'finish' ? 'Завершить заявку' : 'Открыть претензию' }}
          el-button(type="danger" @click="resetOrderModifying()") Отменить
    el-dialog(:visible.sync="showOrderComments" :before-close="resetOrderComments" :title="commentsOrderTitle" width="50%")
      Comments(:orderId="commentsOrder.id" :list="orderComments")
    el-dialog(:visible.sync="isBlacklistAdding" :before-close="resetBlacklistAdd" title="Добавление в ЧС" width="50%")
      .dialog__container
        .dialog-value__container
          .dialog-value__title {{ addingBlacklist.type === 'requisite' ? 'Реквизит' : 'Пользователь' }}
          .dialog-value__input
            el-input(v-model="addingBlacklist.value" :disabled="true")
        .dialog-value__container
          .dialog-value__title Примечание
          .dialog-value__input
            el-input(v-model="addingBlacklist.note")
        .dialog-buttons__container
          el-button(type="success" @click="changeBlackListStatus(addingBlacklist.value, 'add', addingBlacklist.type, addingBlacklist.note)") Добавить
          el-button(type="danger" @click="resetBlacklistAdd") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CANCEL_CLAIM, CANCEL_ORDER,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ORDERS_LIST,
  OPEN_CLAIM, SWITCH_NOTE
} from '../../store/const/orders';
import Comments from './Comments';
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER,
  DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER
} from '../../store/const/exchange';
import instruments from '../../mixins/instruments';

export default {
  name: 'OrdersList',
  components: {
    Comments,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      page: 1,
      per_page: 50,
      isRequisiteAdding: false,
      addingRequisiteOrder: {
        id: null,
        description: null,
        messages: [],
        requisite: '',
      },
      activeOptions: [
        { key: 'all', locale: 'Все' },
        { key: 'active', locale: 'Активные' },
        { key: 'finished', locale: 'Завершенные' },
        { key: 'ignore_refused', locale: 'Без отказов' },
        { key: 'canceled', locale: 'Отмененные' },
        { key: 'paid', locale: 'Оплаченные' },
        { key: 'problem', locale: 'Проблемные' },
      ],
      activeMode: localStorage.getItem('orders_activeMode') || 'all',
      paymentSystemMode: localStorage.getItem('orders_paymentSystemMode') || '',
      searchValue: '',
      searchLoaded: false,
      searchMode: localStorage.getItem('orders_searchMode') || 'id',
      finishAvailableStatuses: [
        'requisite_added',
        'requisite_sent',
        'paid',
        'canceled',
        'claim',
        'finish_error',
        'cancel_error',
        'wait_cancel',
      ],
      claimAvailableStatuses: [
        'requisite_added',
        'requisite_sent',
        'paid',
        'canceled',
        'cancel_error',
        'wait_cancel',
      ],
      cancelAvailableStatuses: [
        'new',
        'requisite_added',
        'requisite_sent',
        'paid',
        'claim',
      ],
      intervalHandle: null,
      isFirstLoading: true,
      isOrderModifying: false,
      modifyingOrder: {
        mode: '',
        id: null,
        amount: null,
        original_amount: null,
        finish_reason: '',
        compensation_order_id: null,
        can_change_amount: false,
        attachment_link: ''
      },
      timeFrom: null,
      timeTo: null,
      finishReason: 'all',
      commentsOrder: {
        id: '',
        comments: [],
      },
      addingBlacklist: {
        type: '',
        value: '',
        note: '',
      },
    };
  },
  watch: {
    activeMode(mode) {
      localStorage.setItem('orders_activeMode', mode);
    },
    paymentSystemMode(mode) {
      localStorage.setItem('orders_paymentSystemMode', mode);
    },
  },
  async mounted() {
    await this.loadOrders();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('orders', [
      'orders',
      'statusesLocales',
      'finishReasons',
    ]),
    ...mapGetters('user', [
      'isAdmin',
      'isPartner',
      'isSupport',
      'username',
    ]),
    ...mapGetters('settings', [
      'paymentSystems',
    ]),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_ORDERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_ORDERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_ORDERS_LIST);
    },
    hasPagination() {
      return this.orders.pagination.count > this.per_page;
    },
    showActionButtons() {
      return !this.isPartner;
    },
    formattedOrders() {
      return this.orders.orders.map((order) => {
        const handlersPseudonyms = {
          saudi: 'SD',
          emirates: 'EM',
          honey: 'HN',
          bridge: 'BR',
        };
        return {
          ...order,
          payment_system: this.paymentSystems[order.payment_system] || order.payment_system,
          handler: handlersPseudonyms[order.handler] || order.handler,
          isCanFinish: this.finishAvailableStatuses.includes(order.status),
          isCanClaim: (this.isAdmin || this.isSupport) && this.claimAvailableStatuses.includes(order.status),
          isCanCancelClaim: (this.isAdmin || this.isSupport) && order.status === 'claim',
          isCanCancel: this.cancelAvailableStatuses.includes(order.status),
          isLink: !!order.requisites && (order.requisites.startsWith('https://') || order.requisites.startsWith('http://')),
          requisites_bank: order.requisites_info?.bank
            ? order.requisites_info.bank_original
              ? `${order.requisites_info.bank} → ${order.requisites_info.bank_original}`
              : order.requisites_info.bank
            : null,
          requisites_recipient: order.requisites_info?.bank_recipient
            ? order.requisites_info.bank_recipient + (order.requisites_info.bank_recipient_lat ? `/${order.requisites_info.bank_recipient_lat}` : '')
            : null,
          requisites_country: order.requisites_info && order.requisites_info.country ? order.requisites_info.country : null,
          showCancelReason: order.cancel_reason && (order.status === 'canceled' || order.status === 'refused' || order.status === 'wait_cancel' || order.status === 'wait_refuse')
        };
      });
    },
    modifyingOrderTitle() {
      return this.modifyingOrder.mode === 'finish'
        ? `Завершение заявки №${this.modifyingOrder.id}`
        : `Открытие претензии по заявке №${this.modifyingOrder.id}`;
    },
    commentsOrderTitle() {
      return `Комментарии к заявке №${this.commentsOrder.id}`;
    },
    showOrderComments() {
      return !!this.commentsOrder.id;
    },
    searchModes() {
      const modes = {
        id: { locale: 'По заявке', title: 'ID заявки' },
        client_id: { locale: 'По клиенту', title: 'ID клиента' },
        code: { locale: 'По ID площадки', title: 'ID площадки' },
        requisites: { locale: 'По реквизитам', title: 'Реквизиты' },
        requisites_parted: { locale: 'По части реквизитов', title: 'Цифры' },
        requisites_last_digits: { locale: 'По последним 4 цифрам', title: 'Цифры' },
        fiat_amount: { locale: 'По сумме заявки', title: 'Сумма заявки' },
      };
      if (this.isAdmin || this.isSupport) {
        modes.deal_id = { locale: 'По сделке', title: 'ID сделки' };
      }
      return modes;
    },
    orderComments() {
      if (this.commentsOrder.id) {
        const order = this.orders.orders.find((order) => order.id === this.commentsOrder.id);
        if (order) {
          return order.comments;
        } else {
          return this.commentsOrder.comments;
        }
      } else {
        return [];
      }
    },
    isBlacklistAdding() {
      return !!this.addingBlacklist.type && !!this.addingBlacklist.value;
    },
  },
  methods: {
    ...mapActions('orders', {
      loadOrdersList: LOAD_ORDERS_LIST,
      editOrder: EDIT_ORDER,
      finishOrder: FINISH_ORDER,
      openClaim: OPEN_CLAIM,
      cancelClaim: CANCEL_CLAIM,
      cancelOrder: CANCEL_ORDER,
      switchNote: SWITCH_NOTE,
    }),
    ...mapActions('exchange', {
      addBlackListUser: ADD_BLACK_LIST_USER,
      deleteBlackListUser: DELETE_BLACK_LIST_USER,
      addBlackListRequisite: ADD_BLACK_LIST_REQUISITE,
      deleteBlackListRequisite: DELETE_BLACK_LIST_REQUISITE,
    }),
    tableRowClassName({ row, rowIndex }) {
      const classes = [];
      if (!this.isPartner) {
        if (row.notes.paid) {
          classes.push('row-success');
        } else if (row.notes.problem) {
          classes.push('row-danger');
        }
      }
      return classes;
    },
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadOrders(this.page), 10000);
    },
    async loadOrders(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
        active: this.activeMode,
      };
      if (this.searchValue) {
        params[this.searchMode] = this.searchValue;
      }
      if (this.timeFrom) {
        params.from = this.timeFrom;
      }
      if (this.timeTo) {
        params.to = this.timeTo;
      }
      if (this.activeMode === 'finished') {
        params.finish_reason = this.finishReason;
      }
      if (this.paymentSystemMode) {
        params.payment_system = this.paymentSystemMode;
      }
      await this.loadOrdersList({ params });
      this.page = page;
      this.searchLoaded = !!this.searchValue;
    },
    async addRequisite() {
      const requisites = this.addingRequisiteOrder.requisite.replace(/ /g, '').trim();
      if (requisites) {
        if (requisites.length > 13 && requisites.length < 19) {
          const request = await this.editOrder({
            id: this.addingRequisiteOrder.id,
            data: { requisites, status: 'wait_send' }
          });
          if (request.success) {
            this.$message.success('Карта успешно добавлена');
            this.resetRequisiteAdd();
            await this.loadOrders(this.page);
          } else {
            this.$message.error(`Ошибка добавления карты: ${request.message || 'Неизвестная ошибка'}`);
          }
        } else {
          this.$message.error('Невалидная карта');
        }
      } else {
        this.$message.error('Введите карту');
      }
    },
    resetRequisiteAdd() {
      this.isRequisiteAdding = false;
      this.addingRequisiteOrder = {
        id: null,
        description: null,
        requisite: '',
      };
    },
    async searchOrder() {
      clearInterval(this.intervalHandle);
      this.searchValue = this.searchValue.trim();
      await this.loadOrders(1, this.searchValue);
    },
    resetSearch() {
      this.searchLoaded = false;
      this.searchValue = '';
      this.loadOrders();
      this.startInterval();
    },
    updateDefaultSearchMode() {
      localStorage.setItem('orders_searchMode', this.searchMode);
    },
    async openOrderModifying(id, amount, mode, status) {
      this.modifyingOrder.id = id;
      this.modifyingOrder.amount = amount;
      this.modifyingOrder.original_amount = amount;
      this.modifyingOrder.mode = mode;
      this.modifyingOrder.can_change_amount = status === 'canceled';
      this.modifyingOrder.attachment_link = '';
      this.isOrderModifying = true;
    },
    async startModifyOrder() {
      const confirmMessage = this.modifyingOrder.mode === 'finish'
        ? `Вы уверены, что хотите завершить заявку №${this.modifyingOrder.id}?`
        : `Вы уверены, что хотите открыть претензию по заявке №${this.modifyingOrder.id}?`;
      this.$confirm(confirmMessage, 'Подтверждение').then(async () => {
        const params = { id: this.modifyingOrder.id };
        if (this.modifyingOrder.mode === 'claim') {
          if (this.modifyingOrder.attachment_link && (!this.isValidURL(this.modifyingOrder.attachment_link) && !this.modifyingOrder.attachment_link.startsWith('claim_'))) {
            return this.$message.warning('Адрес чека не валидный');
          }
          params.data = { attachment_link: this.modifyingOrder.attachment_link };
          params.data.fiat_amount = this.modifyingOrder.can_change_amount
            ? parseInt(this.modifyingOrder.amount)
            : this.modifyingOrder.original_amount;
        } else {
          if (this.modifyingOrder.can_change_amount && (parseInt(this.modifyingOrder.amount) !== this.modifyingOrder.original_amount)) {
            params.data = { fiat_amount: parseInt(this.modifyingOrder.amount) };
          }
        }
        let request;
        if (this.modifyingOrder.mode === 'finish') {
          if (!this.modifyingOrder.finish_reason) {
            return this.$message.warning('Укажите причину завершения заявки');
          }
          if (!params.data) {
            params.data = {};
          }
          if (this.modifyingOrder.finish_reason === 'compensation' || this.modifyingOrder.finish_reason === 'duplicate') {
            if (!this.modifyingOrder.compensation_order_id) {
              return this.$message.warning('Укажите ID связной заявки');
            }
            params.data.compensation_order_id = this.modifyingOrder.compensation_order_id;
          }
          params.data.reason = this.modifyingOrder.finish_reason;
          request = await this.finishOrder(params);
        } else {
          request = await this.openClaim(params);
        }
        this.handleRequestAndNotify({
          request,
          successMessage: this.modifyingOrder.mode === 'finish'
            ? 'Заявка успешно завершена'
            : 'Претензия успешно открыта',
          successMethod: this.resetOrderModifying,
        });
      }).catch(() => {
        this.$message.info('Завершение отменено');
      });
    },
    async startCancelClaim(id) {
      this.$confirm('Вы уверены, что хотите отменить претензию?', 'Подтверждение').then(async () => {
        const request = await this.cancelClaim({ id });
        this.handleRequestAndNotify({
          request,
          successMessage: 'Претензия отменена',
          errorMessage: 'Ошибка отмены претензии',
          successMethod: this.resetOrderModifying,
        });
      }).catch(() => {
        this.$message.info('Отменено');
      });
    },
    resetOrderModifying() {
      this.modifyingOrder.mode = '';
      this.modifyingOrder.id = null;
      this.modifyingOrder.amount = null;
      this.modifyingOrder.finish_reason = '';
      this.modifyingOrder.compensation_order_id = null;
      this.modifyingOrder.can_change_amount = false;
      this.modifyingOrder.attachment_link = '';
      this.isOrderModifying = false;
    },
    async startCancelOrder(id) {
      this.$confirm('Вы уверены, что хотите отменить заявку?', 'Подтверждение').then(async () => {
        const request = await this.cancelOrder({ id });
        this.handleRequestAndNotify({
          request,
          successMessage: 'Заявка успешно отменена',
          errorMessage: 'Ошибка отмены заявки',
        });
      }).catch(() => {
        this.$message.info('Отменено');
      });
    },
    async changeBlackListStatus(value, mode = 'add', type = 'user', note) {
      const confirmMessage = mode === 'add'
        ? `Вы уверены, что хотите добавить ${type === 'user' ? 'пользователя' : 'реквизит'} ${value} в черный список?`
        : `Вы уверены, что хотите удалить ${type === 'user' ? 'пользователя' : 'реквизит'} ${value} из черного списка?`;
      this.$confirm(confirmMessage, 'Подтверждение').then(async () => {
        let request = {};
        if (mode === 'add') {
          if (type === 'user') {
            request = await this.addBlackListUser({ user: value, note });
          } else {
            request = await this.addBlackListRequisite({ requisite: value, note });
          }
        } else {
          if (type === 'user') {
            request = await this.deleteBlackListUser(value);
          } else {
            request = await this.deleteBlackListRequisite(value);
          }
        }
        this.handleRequestAndNotify({ request });

        if (request.success && mode === 'add') {
          this.resetBlacklistAdd();
        }
      }).catch(() => {
        this.$message.info('Отменено');
      });
    },
    async handleOrderNote(order, type) {
      const request = await this.switchNote({ id: order.id, type });
      if (request.success) {
        order.notes[type] = !order.notes[type];
      } else {
        this.$message.error(request.message || 'Неизвестная ошибка');
      }
    },
    copyOrderInfo(order) {
      let info = `${order.id}`;
      if (order.deal_id) {
        info += ` (${order.deal_id})`;
      }
      if (order.requisites) {
        info += `\n${order.requisites}`;
      }
      this.copyTextToClipboard(info);
    },
    openOrderComments(id, comments) {
      this.commentsOrder.comments = comments;
      this.commentsOrder.id = id;
    },
    resetOrderComments() {
      this.commentsOrder.id = '';
      this.commentsOrder.comments = [];
    },
    openBlacklistAdd(value, type) {
      this.addingBlacklist.type = type;
      this.addingBlacklist.value = value;
    },
    resetBlacklistAdd() {
      this.addingBlacklist.type = '';
      this.addingBlacklist.value = '';
      this.addingBlacklist.note = '';
    },
    formatRequisitesUrl(str) {
      const url = new URL(str);
      const domain = url.hostname;
      const path = url.pathname;

      const last5 = path.slice(-5);

      return `${domain}/...${last5}`;
    }

  }
};
</script>
<style>
.messages__container {
  border: 1px solid lightgrey;
  padding: 5px;
  margin: 5px auto;
}

.requisite-add__buttons {
  margin-top: 10px;
}

.filters__container {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  border: 1px solid #cfcfcf;
}

.filter__container {
  text-align: center;
  padding: 2px;
}

.filter__container.one-line {
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter__container.search {
  margin-left: auto;
}

.filter__title {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 2px;
}

.search__container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.search-reset__btn {
  padding: 11px;
  background-color: #e95050;
  cursor: pointer;
}

.search-reset__btn:hover {
  padding: 10px;
  background-color: #dd3636;
  border: 1px solid #850202;
}

.col-title {
  font-weight: 500;
  margin-right: 5px;
}

.order-action__buttons {
  display: flex;
  height: 50px;
  align-items: flex-end;
}

.order-action__buttons .action__btn {
  margin: 0 1px;
  position: relative;
}

.order-action__buttons .action__btn button {
  /*width: 100%;*/
}

.original-amount {
  margin-bottom: 10px;
  font-weight: bold;
}

.search__container .el-select {
  width: 250px;
}

.order-black-list__btn {
  cursor: pointer;
  margin-left: 5px;
}

.black-list-user {
  color: #F56C6C;
  text-decoration: line-through;
}

.dialog-action__buttons {
  display: flex;
}

.dialog-action__buttons .action__btn {
  margin: auto 2px;
}

.exchanges-checkbox__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.exchange-checkbox {
  padding: 10px;
  margin-bottom: 5px;
}

.note-icon {
  cursor: pointer;
  margin: 0 2px;
  font-size: 20px;
  font-weight: bold;
}

.copy__btn {
  margin-right: 5px;
  cursor: pointer;
}

.partner-order {
  background-color: #c5c5c5 !important;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date__title {
  margin-right: 5px;
  font-size: 12px;
  font-weight: bold;
}

.comments__badge {
  position: absolute;
  width: 20px;
  height: 20px;
  right: -6px;
  top: -6px;
  padding: 2px;
  border: 1px solid #f9fbff;
  background-color: #2a7bcf;
  color: #f9fbff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.finish-reason {
  margin: 5px auto;
}

.finish-reason-param {
  margin-bottom: 5px;
}

.dialog-value__container {
  padding: 4px;
  margin-bottom: 4px;
}

.dialog-value__title {
  font-weight: bold;
  margin-bottom: 4px;
}

.dialog-buttons__container {
  margin-top: 10px;
}

.requisite__text {
  display: inline;
}
</style>
